import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import AppWrapper from "./AppWrapper";
import reportWebVitals from './reportWebVitals';
import { BrowserRouter as Router } from "react-router-dom";
import { ToastContainer } from "react-toastify";
import 'react-reflex/styles.css';
import { registerLicense } from '@syncfusion/ej2-base';
import { AuthProvider } from "./context/AuthProvider";
// at app bootstrap (before any grid renders)
import { ModuleRegistry } from 'ag-grid-community';
import {
  ServerSideRowModelModule,
  SetFilterModule,
  TextFilterModule,
  NumberFilterModule,
  DateFilterModule,
  ColumnsToolPanelModule,
  FiltersToolPanelModule, 
  AllEnterpriseModule, 
  LicenseManager 
} from 'ag-grid-enterprise';

ModuleRegistry.registerModules([
  AllEnterpriseModule,
  ServerSideRowModelModule,
  SetFilterModule,
  TextFilterModule,
  NumberFilterModule,
  DateFilterModule,
  ColumnsToolPanelModule,
  FiltersToolPanelModule,
]);

LicenseManager.setLicenseKey(process.env.REACT_APP_AG_GRID_LICENSE_KEY || '');

// Registering Syncfusion license key
registerLicense("NxYtGyMROh0gHDMgDk1jXU9FaF5FVmJLYVB3WmpQdldgdVRMZVVbQX9PIiBoS35Rc0RiW35edXZdQmhfVkN2VEFc");

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <>
    <AuthProvider>
      <Router>
        <AppWrapper />
      </Router>
      <ToastContainer
        position="bottom-right"
        autoClose={5000}
        hideProgressBar={false}
        newestOnTop={false}
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover
      />
    </AuthProvider>
  </>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals

// DEFAULT SCRIPTS
// "start": "react-scripts start",
// "build": "CI= react-scripts build",
// "test": "react-scripts test",
// "eject": "react-scripts eject"
reportWebVitals();
